import { render, staticRenderFns } from "./SignUpCompleted.vue?vue&type=template&id=6d5b7119"
import script from "./SignUpCompleted.vue?vue&type=script&lang=js"
export * from "./SignUpCompleted.vue?vue&type=script&lang=js"
import style0 from "./SignUpCompleted.vue?vue&type=style&index=0&id=6d5b7119&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports